// extracted by mini-css-extract-plugin
export var fadeInAnimation = "TopProjects-module--fadeInAnimation--5c9f6";
export var wrapper = "TopProjects-module--wrapper--31ad7";